import { configureAuth } from 'react-query-auth';
import { axios } from './axios';
import { getCurrentUser } from '@/api/user';
import { LOGOUT } from '@/constants/API';
import { loginWithUsernameAndPassword, registerWithEmailAndPassword } from '@/modules/auth';
import { logout } from '@/services/auth';
import { LoginCredentialsDTO, SignupProps } from '@/types/auth';
import storage from '@/utils/storage';

const { useUser, useLogin, useRegister, useLogout } = configureAuth({
  userFn: async () => {
    try {
      const webAccessToken = storage.getItem('webAccessToken');
      if (!webAccessToken) return null;
      const user = await getCurrentUser();
      return user;
    } catch (error) {
      return null;
    }
  },
  loginFn: async (credentials: LoginCredentialsDTO) =>
    await loginWithUsernameAndPassword(credentials),
  registerFn: async (credentials: SignupProps) => await registerWithEmailAndPassword(credentials),
  logoutFn: async () => {
    const webAccessToken = storage.getItem('webAccessToken');
    if (webAccessToken) {
      await axios.get(LOGOUT);
    }
    logout();
  },
});

export { useUser, useLogin, useRegister, useLogout };
